import React, { useEffect, useMemo, useState } from 'react';
import { PointsForDrawingsList, getCMSObject } from 'sg-ui-components';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../../Store';
import { FaTicketAlt, FaWallet, FaRegClock } from 'react-icons/fa';

const PointsForDrawingsSection = ({ actions, config, pointsForDrawings, user }) => {
    const [pageLoaded, setPageLoaded] = useState(false);
    const pointsForDrawingTelescript = getCMSObject('data.components.teleScripts.pointsForDrawings.jsonBlock');

    useEffect(() => {
        async function fetchData() {
            await actions?.pointsForDrawingsActions?.getPointsForDrawings();
            setPageLoaded(true);
        }

        fetchData();
    }, [user.loggedIn, setPageLoaded]);

    const currentDrawings = useMemo(() => pointsForDrawings.pointsForDrawings?.filter((item) => item.category === 'current'), [pointsForDrawings]);

    return (
        <div>
            <PointsForDrawingsList
                config={config}
                action={actions}
                user={user}
                mode={'show-limited'}
                data={currentDrawings}
                pageLoaded={pageLoaded}
                telescript={pointsForDrawingTelescript}
                options={{
                    hasCollapser: true,
                    variant: 'theme-primary current-pfd',
                    dateIcon: <FaRegClock className='pfd-date-icon' size={18} />,
                    pointIcon: <FaWallet className='pfd-point-icon' size={16} />,
                    entryIcon: <FaTicketAlt className='pfd-entry-icon' size={18} />,
                }}
                placeholderImageLink={pointsForDrawingTelescript?.placeholderImageLink}
            />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PointsForDrawingsSection);
